import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";

// public pages
import PublicHomepage from "components/PublicHomepage";
// import PublicSignIn from "components/PublicSignIn";
// import PublicSignOut from "components/PublicSignOut";
import PublicNotFound from "components/PublicNotFound";
import ErrorPage from "shared/Error";

// private pages
import AppWrapper from "components/AppWrapper";
import Dashboard from "components/Dashboard";
import Page from "components/Page";
import ExtractBuilder from "components/ExtractBuilder";
import NotFound from "components/NotFound";
import Accounts from "components/AccountsPage/accounts";

import { AppProvider, AppContext } from "components/AppContext";
import "styles/App.scss";
// import Analytics from "components/Analytics";

const PublicRoutes = () => (
  <Switch>
    <Route path="/" exact component={PublicHomepage} />
    {/* <Route path="/sign-in" exact component={PublicSignIn} /> */}
    {/* <Route path="/sign-out" exact component={PublicSignOut} /> */}
    <Route path="/errordisplay" component={ErrorPage} />
    <Route path="*" component={PublicNotFound} />
  </Switch>
);

const PrivateRoutes = () => {
  const { ready, loggedIn } = useContext(AppContext);

  if (!ready) {
    return <div>Loading</div>;
  }
  if (loggedIn) {
    return (
      <AppWrapper>
        <Switch>
          <Route path="/app" exact component={Accounts} />
          <Route path="/app/account/:id" exact component={Dashboard} />
          {/* <Route path="/app/analytics" exact component={Analytics} /> */}
          <Route path="/app/users" exact component={Dashboard} />
          <Route path="/app/accounts" exact component={Dashboard} />
          <Route
            path="/app/account/:accountId/reports/new"
            exact
            component={ExtractBuilder}
          />
          <Route
            path="/app/account/:accountId/dags/:dagId/reports/:extractId"
            exact
            component={ExtractBuilder}
          />
          <Route path="/accounts" exact component={Dashboard} />
          <Route path="/data-access-groups" exact component={Dashboard} />
          <Route path="/users" exact component={Dashboard} />
          <Route path="/help" exact component={Dashboard} />
          <Route path="/feedback" exact component={Dashboard} />
          <Route path="/settings" exact component={Dashboard} />
          <Route path="/app/pages/:id" exact component={Page} />
          <Route path="/app/errordisplay" component={ErrorPage} />
          <Route path="*" component={NotFound} />
        </Switch>
      </AppWrapper>
    );
  }
  if (!loggedIn) {
    return (
      <Switch>
        <Route path="/" exact component={PublicHomepage} />
        {/* <Route path="/sign-in" exact component={PublicSignIn} /> */}
        {/* <Route path="/sign-out" exact component={PublicSignOut} /> */}
        <Route path="*" component={PublicNotFound} />
      </Switch>
    );
  }
  return <Redirect to="/" />;
};

const App = () => {
  return (
    <Router>
      <ScrollToTop>
        <AppProvider>
          <Switch>
            <Route path="/app" component={PrivateRoutes} />
            <Route path="*" component={PublicRoutes} />
          </Switch>
        </AppProvider>
      </ScrollToTop>
    </Router>
  );
};

export default App;
